import queryEnv from "constants/queryConst";

const FORM_VIEW_QUERY_KEYS = [
  "viewForms",
  "viewPass",
  "showPass",
  "viewBalanceAdjustment",
  "viewFormCorrected",
  "viewFormCorrect",
  "viewReviewFormCorrect",
  "revisionTime",
  "revisionInProgress",
  queryEnv.INTEGRATION_BOX,
  queryEnv.INTEGRATION_BOX_CORRECTED,
];

export function invalidateFormViews(queryClient) {
  if (!queryClient) return;
  FORM_VIEW_QUERY_KEYS.forEach((queryKey) => {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
  });
}
